export enum ClaimRoutesQueryParam {
  Cases = 'cases',
  Claims = 'claims',
  Payments = 'payments',
}

export enum EnterpriseRoutesQueryParam {
  Provider = 'provider',
  ProviderGroup = 'provider-group',
  ProviderNetwork = 'provider-network',
  ProviderPriceList = 'provider-price-list',
  Person = 'person',
  Policy = 'policy',
  PolicyHolderGroups = 'policyholder-group',
  Products = 'products',
  Benefits = 'benefits',
  Limits = 'limits',
  Applications = 'applications',
  Brokers = 'brokers',
}

export enum PharmacyRoutesQueryParam {
  NationalDrugs = 'national-drugs',
  ExternalDrugData = 'external-drug-data',
  MasterDrugs = 'master-drugs',
  DrugInteractions = 'drug-interactions',
  NationalDrugFormularies = 'national-drug-formularies',
  DrugManagementPlans = 'drug-management-plans',
  Manufacturers = 'manufacturers',
  Ingredients = 'ingredients',
  ATCCodes = 'atc-codes',
}

export enum DataCenterRoutesQueryParam {
  MemberData = 'member-data',
  ExternalData = 'external-data',
}
